module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "epigraph"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/OEBPS/pppmaddog006#maintoc"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('p', {
    staticClass: "epf"
  }, [_vm._v("Mad dogs and Englishmen"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("go out in the mid-day sun…")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("—Noel Coward"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("Mad Dogs and Englishmen")]), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('p', {
    staticClass: "epf"
  }, [_vm._v("An artificial intercontinental flight vehicle does not impress someone whose hematasooma (soul) is capable of superluminal intergalactic space travel.")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("—Karl H. Schlesier")]), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('p', {
    staticClass: "epf"
  }, [_vm._v("The Wolves of Heaven: Cheyenne Shamanism, Ceremonies, and Prehistoric Origins"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("Oh, you can’t go back to Kansas,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("It just up and blew away…"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("…you can’t go back to Kansas,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("’cause that was yesterday.")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("—John Stewart"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("“Kansas,” The Phoenix Concerts")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d42e3094","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ppp-maddog005.vue
// module id = 69
// module chunks = 0